module.exports = __webpack_public_path__ + "static/media/Leavanny_gaussian2.3a75eda6.png";